import PropTypes from "prop-types"
import React from "react"
import Box from "@mui/material/Box"
import TextField from "@mui/material/TextField"
import Autocomplete from "@mui/material/Autocomplete"
import { COUNTRIES } from "../../constants/countries"

/**
 * CountrySelect
 * @param {object} props
 * @param {string|null} props.value - El código ISO del país seleccionado o null
 * @param {function} props.onChange - Callback (event, newValue) => void
 * @param {object} [props.sx] - Estilos sx opcionales para el Autocomplete
 * @param {string} [props.label] - Etiqueta opcional para el TextField
 */
const CountrySelect = ({
  value = null,
  onChange,
  sx,
  label = "País",
  ...rest
}) => {
  return (
    <Autocomplete
      options={COUNTRIES}
      autoHighlight
      getOptionLabel={option => option.label}
      value={COUNTRIES.find(c => c.code === value) || null}
      onChange={(event, newValue) => {
        onChange && onChange(event, newValue ? newValue.code : null)
      }}
      sx={sx}
      renderOption={(props, option) => (
        <Box
          component="li"
          sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
          {...props}
        >
          <img
            loading="lazy"
            width="20"
            src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
            srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
            alt=""
          />
          {option.label}
        </Box>
      )}
      renderInput={params => (
        <TextField
          {...params}
          label={label}
          inputProps={{
            ...params.inputProps,
            autoComplete: "new-password", // disable autocomplete and autofill
          }}
        />
      )}
      {...rest}
    />
  )
}

export default CountrySelect

CountrySelect.propTypes = {
  value: PropTypes.string, // código ISO
  onChange: PropTypes.func,
  sx: PropTypes.object,
  label: PropTypes.string,
}
